import '../_scss/app.scss'
import { createApp } from "vue";
import VueSocialSharing from "vue-social-sharing";
import { initHeader } from "./header";
import { textTabsMedia } from "./text-tabs-media";
import { mediaAccordion } from "./media-accordion";
import { mediaIframe } from "./media-iframe";
import { interactiveMedia } from "./interactive-media";
import { leadershipDialog } from "./leadership-dialog";
import { videoDialog } from "./video-dialog";
import { ambientMedia } from "./ambient-media";
import { motionAtIntersections, heroAnimationSwap, countingNumbers } from "./motion";
import { numbers } from "./numbers";
import Careers from "./_vue/components/Careers.vue";
import ResourceFilters from "./_vue/components/ResourceFilters.vue";
import ResourceSearch from "./_vue/components/ResourceSearch.vue";
import ResourceSearchPage from "./_vue/components/ResourceSearchPage.vue";
import Resources from "./_vue/components/Resources.vue";
import SocialShare from "./_vue/components/SocialShare.vue";
import { copyUrl } from "./copy-url";
import { guidesEntryToc, guidesEntryActiveNav, guidesEntryMobileNav } from "./guides-entry";
import { Splide } from "@splidejs/splide";
import InstantSearch from "vue-instantsearch/vue3/es";
import { vSplide } from "./splide-directive";

const app = createApp({
  delimiters: ["${", "}"],
  mounted() {
    initHeader();
    textTabsMedia();
    mediaAccordion();
    mediaIframe();
    interactiveMedia();
    leadershipDialog();
    videoDialog();
    ambientMedia();
    motionAtIntersections();
    heroAnimationSwap();
    countingNumbers();
    numbers();
    copyUrl();
    guidesEntryToc();
    guidesEntryActiveNav();
    guidesEntryMobileNav();

    document.querySelectorAll(".splide").forEach((splide) => {
      new Splide(splide, {
        mediaQuery: "min",
      }).mount();
    });
  },
  components: {
    careers: Careers,
    "resource-filters": ResourceFilters,
    "resource-search": ResourceSearch,
    "resource-search-page": ResourceSearchPage,
    resources: Resources,
    "social-share": SocialShare,
  },
});

app.use(VueSocialSharing);
app.use(InstantSearch);
app.directive("splide", vSplide);
app.mount("#app");


// Accept HMR updates
if (import.meta.hot) {
  import.meta.hot.accept()
}
